import { isBrowser } from "./browser";
import type { AnalyticsContext, AnalyticsDevice } from "./events";

export function classifyDevice(
  userAgent = isBrowser() ? window.navigator.userAgent : "",
  maxTouchPoints = isBrowser() ? window.navigator.maxTouchPoints || 0 : 0,
  platform = isBrowser() ? window.navigator.platform : "",
): AnalyticsDevice {
  const ua = userAgent || "";
  const isIpadOs =
    /iPad/i.test(ua) ||
    (platform === "MacIntel" && maxTouchPoints > 1);
  if (isIpadOs || /Tablet|PlayBook|Silk/i.test(ua)) {
    return "tablet";
  }
  if (/Mobi|Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return "mobile";
  }
  return "desktop";
}

export function currentPagePath(): string | null {
  if (!isBrowser()) return null;
  const path = window.location.pathname;
  return path || "/";
}

export function buildEventContext(): AnalyticsContext {
  if (!isBrowser()) {
    return {
      pageUrl: null,
      referrer: null,
      country: null,
      device: null,
    };
  }

  return {
    // Path only. Origin and query belong in UTM / properties, not this column.
    pageUrl: currentPagePath(),
    referrer: null,
    // No trusted geo value is available on the client without an extra lookup.
    country: null,
    device: classifyDevice(),
  };
}
